import { getAuthHeader } from "../utils/superagent";
import request from "superagent";
import {
  ITripResponseType,
  NewTripResponse,
} from "../containers/facilityDashboard/ShiftCalendar/dayView/workerETA/types";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { environmentConfig } from "@src/appV2/environment";
import { isDefined, toError } from "@clipboard-health/util-ts";
import { ITrip } from "@src/containers/liveMapView/types";
import { HCF_USER_EVENTS } from "@src/constants/analyticsEvents";
import { logEvent } from "@src/appV2/lib/analytics";
import {
  convertNewTripResponsesToITrips,
  convertNewTripResponseToITripResponse,
} from "@src/containers/facilityDashboard/ShiftCalendar/dayView/workerETA/convert-new-trip-response-to-i-trip";

const workerEtaApi = environmentConfig.REACT_APP_API_MAIN_URL;

export class WorkerEtaForbiddenError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "WorkerEtaForbiddenError";
  }
}

async function fetchWorkerTrips(parameters: {
  tripIds: Array<{ shiftId: string; workerId: string }>;
  workplaceId: string | undefined;
}): Promise<NewTripResponse[]> {
  try {
    const { tripIds, workplaceId } = parameters;
    if (!isDefined(workplaceId)) {
      logEvent(HCF_USER_EVENTS.WORKER_ETA_ERROR, {
        error: "Workplace ID is undefined",
        ...parameters,
      });
      return [];
    }
    const queryParams = {
      ...(tripIds.length > 0 && {
        "filter[trip.id]": tripIds.map((trip) => `${trip.shiftId}-${trip.workerId}`).join(","),
      }),
    };
    const authHeader = await getAuthHeader();
    const { body } = await request
      .get(`${workerEtaApi}/api/workplaces/${workplaceId}/trips`)
      .query(queryParams)
      .set(authHeader);
    return body;
  } catch (maybeError: unknown) {
    const error = toError(maybeError);
    const statusCode =
      typeof maybeError === "object" && maybeError !== null && "status" in maybeError
        ? (maybeError as { status: number }).status
        : undefined;

    logEvent(HCF_USER_EVENTS.WORKER_ETA_ERROR, {
      error: error.message,
      ...parameters,
    });

    if (statusCode === 403) {
      throw new WorkerEtaForbiddenError(error.message);
    }

    showErrorToast(error.message);
    return [];
  }
}

export async function getWorkerTrip(parameters: {
  workerId: string;
  shiftId: string;
  workplaceId: string | undefined;
}): Promise<ITripResponseType | undefined> {
  const { workerId, shiftId, workplaceId } = parameters;
  const trips = await fetchWorkerTrips({ tripIds: [{ shiftId, workerId }], workplaceId });
  const convertedTrips = trips.map(convertNewTripResponseToITripResponse);
  return convertedTrips[0];
}

export async function getWorkerTrips(parameters: {
  tripIds: Array<{ shiftId: string; workerId: string }>;
  workplaceId: string | undefined;
}): Promise<ITrip[]> {
  const { tripIds, workplaceId } = parameters;
  try {
    const trips = await fetchWorkerTrips({ tripIds, workplaceId });
    const convertedTrips = convertNewTripResponsesToITrips(trips);
    return convertedTrips;
  } catch (error) {
    if (error instanceof WorkerEtaForbiddenError) {
      return [];
    }
    throw error;
  }
}
